import React from 'react';
import { BottomSheetDialog } from '@medely/web-components';
import { PostBookingInfoLegacy } from './PostBookingInfoLegacy';
import { PostBookingInfo } from './PostBookingInfo';
import { PostBookingModalProps } from './interface';
import useDevice from '@mp/hooks/useDevice.web';
import { gateNames } from '@mp/constants';
import { useGate } from '@mp/hooks';
import useDialog from '@mp/hooks/useDialog';
import { CalendlyModal } from '../calendlyModal/CalendlyModal';

export const PostBookingModal = ({
  onClose,
  open,
  cancelationPolicyButton,
  job,
  jobMap,
  userCoordinates,
}: PostBookingModalProps) => {
  const isDesktop = useDevice() === 'desktop';
  const showNewPostBookingInfo = useGate(gateNames.rescreening_automation);
  const calendlyDialog = useDialog();

  const handleScheduleRescreening = () => {
    onClose();
    calendlyDialog.openDialog();
  };

  return (
    <>
      <BottomSheetDialog
        open={open}
        onClose={onClose}
        title="Your shift is booked"
        data-testid="post-booking-dialog"
        isDesktop={isDesktop}
        fullScreen
        sx={{ top: isDesktop ? '32px' : 0 }}
        content={
          showNewPostBookingInfo ? (
            <PostBookingInfo job={job} onScheduleRescreening={handleScheduleRescreening} />
          ) : (
            <PostBookingInfoLegacy
              cancelationPolicyButton={cancelationPolicyButton}
              jobMap={jobMap}
              job={job}
              userCoordinates={userCoordinates}
            />
          )
        }
      />
      <CalendlyModal open={calendlyDialog.open} onClose={calendlyDialog.closeDialog} />
    </>
  );
};
